import React, { useEffect, useMemo, useState } from 'react';
import { useApi } from '@sdir/httpclient/lib/hooks/useApi';
import { useCurrentUser } from '@sdir/auth/lib/hooks';
// eslint-disable-next-line max-len
import { EndorsementServiceFeaturesGetReporteesV2GetReporteesDto as ReporteesDto } from '@sdir/httpclient/lib/clients/aps/endorsement';
import { endorsementApi } from '../../httpclient';
import { asLoadable } from '../../types';
import { ReporteesContext } from '../../services/contexts/ReporteesContext';

interface ReporteesProviderProps {
  children?: any;
}

export const ReporteesProvider: React.FC<ReporteesProviderProps> = ({ children }) => {
  const [reportees, setReportees] = useState<ReporteesDto[]>();
  const currentUser = useCurrentUser();

  const {
    errorObject: reporteesError,
    loading: reporteesLoading,
    callApi: getReportees,
  } = useApi({
    apiFunction: () => endorsementApi.getReporteesV2(),
    successCallback: (result) => {
      setReportees(result || []);
    },
  });

  useEffect(() => {
    if (!reporteesLoading && !reporteesError && !reportees) {
      getReportees();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reporteesLoading]);

  useEffect(() => {
    let items = reportees || [];
    if (!items || items.length === 0) {
      items = [
        {
          id: currentUser?.profile?.reportee,
          name: currentUser?.profile?.reporteeName,
          email: '',
        },
      ];
      setReportees(items);
    }
  }, [currentUser?.profile, reportees]);

  const data = asLoadable<ReporteesDto[]>(reportees, reporteesError, reporteesLoading);
  const value = {
    data,
    callApi: getReportees,
  };

  return <ReporteesContext.Provider value={value}>{children}</ReporteesContext.Provider>;
};
